module.exports = __webpack_public_path__ + "static/media/covid_adolescent_p5_1.c5070ad4.png";